import { render } from "./KategoriProduct.vue?vue&type=template&id=371d7b91"
import script from "./KategoriProduct.vue?vue&type=script&lang=js"
export * from "./KategoriProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__